import { render, staticRenderFns } from "./MenuCategories.vue?vue&type=template&id=52a05551&scoped=true&"
import script from "./MenuCategories.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MenuCategories.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MenuCategories.vue?vue&type=style&index=0&id=52a05551&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a05551",
  null
  
)

export default component.exports